<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { onMounted } from 'vue'

import { TEST_IDS_CREATE } from '@/_testIds/testIdsCreate'
import CollapsableContent from '@/components/common/layout/CollapsableContent.vue'
import DateInput from '@/components/common/ui/inputs/DateInput.vue'
import FormSelect from '@/components/common/ui/inputs/FormSelect.vue'
import InputGrid from '@/components/common/ui/inputs/InputGrid.vue'
import TextInput from '@/components/common/ui/inputs/TextInput.vue'
import TWTextArea from '@/components/common/ui/inputs/TWTextArea.vue'
import { useBackendConstantsStore } from '@/stores/backendConstantsStore'
import { translationFunctionDefault } from '@/utilities/translations'

interface SectionGeneralDataPersonProps {
  inCreateContext?: boolean
  onSubmit?: (() => void) | undefined
}

defineProps<SectionGeneralDataPersonProps>()

const tfDefault = translationFunctionDefault()

const backendConstantsStore = useBackendConstantsStore()
const { fetchSalutationList } = backendConstantsStore
const { salutationOptionList } = storeToRefs(backendConstantsStore)

onMounted(async () => {
  await fetchSalutationList()
})
</script>

<template>
  <CollapsableContent :title="tfDefault('editPerson.generalDataTitle')">
    <InputGrid :columns="2">
      <div class="col-span-2">
        <FormSelect
          :data-testid="TEST_IDS_CREATE.sectionGeneralDataPerson.title"
          :label="tfDefault('editPerson.generalDataAcademicTitle')"
          name="salutation"
          on-white-bg
          :options="[salutationOptionList]"
          :placeholder="tfDefault('editRelationGroup.selectPlaceholder')"
          searchable
          @blur="onSubmit"
        />
      </div>
      <TextInput
        :data-testid="TEST_IDS_CREATE.sectionGeneralDataPerson.firstName"
        :in-create-context="inCreateContext ?? false"
        :label="tfDefault('editPerson.generalDataFirstName')"
        name="first_name"
        required
        @blur="onSubmit"
      />
      <TextInput
        :data-testid="TEST_IDS_CREATE.sectionGeneralDataPerson.lastName"
        :in-create-context="inCreateContext ?? false"
        :label="tfDefault('editPerson.generalDataLastName')"
        name="last_name"
        required
        @blur="onSubmit"
      />
      <DateInput
        class="col-span-2"
        :in-create-context="inCreateContext ?? false"
        :label-text="tfDefault('editPerson.generalDataBirthday')"
        name="tw_date_of_birth"
        :testid="TEST_IDS_CREATE.sectionGeneralDataPerson.birthday"
        @blur="onSubmit"
      />
    </InputGrid>

    <InputGrid :columns="1">
      <TWTextArea
        :data-testid="TEST_IDS_CREATE.sectionGeneralDataPerson.description"
        :in-create-context="inCreateContext ?? false"
        :label="tfDefault('editPerson.generalDataDescription')"
        name="tw_description"
        @blur="onSubmit"
      />

      <TWTextArea
        :data-testid="TEST_IDS_CREATE.sectionGeneralDataPerson.metVia"
        :in-create-context="inCreateContext ?? false"
        :label="tfDefault('editPerson.generalDataMetVia')"
        name="tw_contact_origin"
        :rows="1"
        @blur="onSubmit"
      />
    </InputGrid>
  </CollapsableContent>
</template>
